module.exports = __webpack_public_path__ + "img/lock.bb9f42f7.svg";